function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .resize-handle {\n    position: absolute;\n    top: 0px;\n    right: 0;\n    transform: translate(50%);\n    width: 5px;\n    z-index: 1;\n    cursor: col-resize;\n    user-select: none;\n\n    &.active-handle,\n    &:hover {\n      &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 50%;\n        border-right: 1px solid black;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "styled-components";
export var resizeHandleStyles = css(_templateObject());
// Copied for modification from
// https://www.brainbell.com/javascript/making-resizable-table-js.html
export default function(table) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, setUpdater = arguments.length > 2 ? arguments[2] : void 0;
    var row = table.getElementsByTagName("tr")[0];
    var cols = row ? row.children : [];
    var paddingDiff = function(col) {
        if (getStyleVal(col, "box-sizing") === "border-box") {
            return 0;
        }
        var padLeft = getStyleVal(col, "padding-left");
        var padRight = getStyleVal(col, "padding-right");
        return parseInt(padLeft) + parseInt(padRight);
    };
    var getStyleVal = function(elm, css) {
        return window.getComputedStyle(elm, null).getPropertyValue(css);
    };
    var clickHandler = function(e) {
        // Prevent sorting from triggering
        e.stopPropagation();
    };
    var mouseDownHandler = function(e) {
        var currentHandle = e.target;
        currentHandle.classList.add("active-handle");
        var curCol = currentHandle.parentElement;
        var nxtCol = curCol === null || curCol === void 0 ? void 0 : curCol.nextElementSibling;
        var pageX = e.pageX;
        var padding = curCol && paddingDiff(curCol) || 0;
        var curColWidth = ((curCol === null || curCol === void 0 ? void 0 : curCol.offsetWidth) || 0) - padding;
        var nxtColWidth = nxtCol ? nxtCol.offsetWidth - padding : 0;
        var globalMouseMove = function(e) {
            var diffX = e.pageX - pageX;
            var nxtNewWidth = nxtColWidth - diffX;
            var curNewWidth = curColWidth + diffX;
            var min = options.minColWidth || 10;
            // Prevent too narrow columns
            if (nxtNewWidth < min && nxtNewWidth < nxtColWidth) return;
            if (curNewWidth < min && curNewWidth < curColWidth) return;
            if (nxtCol) {
                nxtCol.style.width = nxtNewWidth + "px";
            }
            if (curCol) curCol.style.width = curNewWidth + "px";
        };
        var globalMouseUp = function(e) {
            currentHandle.classList.remove("active-handle");
            document.removeEventListener("mousemove", globalMouseMove);
            document.removeEventListener("mouseup", globalMouseUp);
            if (options.memoryKey) {
                var colWidths = Array.from(cols).map(function(col) {
                    return (col.style.width || "").match(/(\d+)px/);
                }).map(function(m) {
                    return m ? +m[1] : null;
                });
                localStorage.setItem("column-widths:".concat(options.memoryKey), JSON.stringify(colWidths));
            }
        };
        document.addEventListener("mousemove", globalMouseMove);
        document.addEventListener("mouseup", globalMouseUp);
        curCol === null || curCol === void 0 ? void 0 : curCol.addEventListener("click", function(e) {
            // Prevent accidental scrolling
            e.stopPropagation();
        });
    };
    var divs = [];
    // Add a resize handle to all columns except the last one
    for(var i = 0; i < cols.length - 1; i++){
        var div = document.createElement("div");
        div.className = "resize-handle";
        div.addEventListener("click", clickHandler);
        div.addEventListener("mousedown", mouseDownHandler);
        divs.push(div);
        cols[i].appendChild(div);
        cols[i].style.position = "relative";
    }
    if (options.memoryKey) {
        try {
            var savedWidths = localStorage.getItem("column-widths:".concat(options.memoryKey));
            if (savedWidths) {
                var colWidths = JSON.parse(savedWidths);
                colWidths.forEach(function(width, i) {
                    if (typeof width !== "number") return;
                    if (!cols[i]) return;
                    if (cols) cols[i].style.width = width + "px";
                });
            }
        } catch (err) {
            console.error("There was an error trying to restore column sizes");
            console.error(err);
        }
    }
    setUpdater(function() {
        divs.forEach(function(div) {
            div.style.height = "".concat(table.offsetHeight, "px");
        });
    });
};
